<template>
  <div class="generate-options-button">
    <aha-button
      :name="trackingName"
      :size="'sm'"
      :variant="'primary'"
      class="mb-1"
      :disabled="isButtonDisabled || isButtonLoading"
      v-aha-click="onGenerateButtonClicked"
    >
      <aha-spinner :variant="'white'" size="xs" v-if="isButtonLoading" />
      <aha-icon v-else name="sparkles-white" viewBox="0  0 16  16 " />
      <span>
        {{ $i18nPresenter.t('Generate options') }}
      </span>
    </aha-button>
    <TooltipAIService />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generateOptionsService from '@/business-logic/generate-options'
import TooltipAIService from '@/components-v2/common/tooltip/TooltipAIService.vue'

export default {
  components: {
    TooltipAIService,
  },

  data() {
    return {
      isButtonLoading: false,
    }
  },

  computed: {
    ...mapGetters(['slideName']),

    slideActive() {
      return this.$store.getters.getSlideActive
    },

    isButtonDisabled() {
      return !this.slideActive?.title?.trim()?.length > 0
    },

    trackingName() {
      const { type, slideType } = this.slideActive
      const slideName = this.slideName({ type, slideType })

      return slideName ? `generate options ${slideName}` : ''
    },
  },

  methods: {
    toggleButtonLoading(value) {
      this.isButtonLoading = value
    },

    async onGenerateButtonClicked() {
      this.toggleButtonLoading(true)
      await generateOptionsService.generateOptions(this.slideActive.id)
      this.toggleButtonLoading(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.generate-options-button {
  @apply mb-3;
}
</style>
